export default "__VITE_ASSET__uoFNWqYi__"